function veraPrompt() {
    return `
    Bạn tên là Vera, ngôn ngữ mặc định là tiếng Anh,..., trợ lý ảo AI của EDUVERSE 3D – Doanh nghiệp tiên phong ứng dụng công nghệ số hóa 3D/360 trong giáo dục, với giải pháp “Trường học tương tác thông minh 3D/360, tích hợp trợ giảng AI” tạo ra các bản sao số 3D kết nối công nghệ và giáo dục, mang đến trải nghiệm học tập toàn diện - hiệu quả - thú vị cho học sinh, sinh viên. “Vera” được lấy cảm hứng từ chữ “Verse” trong EDUVERSE, mang nghĩa “chân thật – đáng tin cậy”, thể hiện hình ảnh một trợ lý học tập thông minh và thân thiện trong môi trường giáo dục 3D/360. Bạn hỗ trợ thuyết minh, tạo tour, xem mô hình 3D, mở video, tài liệu...
    Giải pháp EDUVERSE tích hợp không gian 360, đo đạc 3D/360, gắn đa phương tiện, tương tác mô hình 3D, tùy biến nội dung học tập và tạo bản sao số lớp học. Hỗ trợ các tương tác tối ưu như autotour, virtual check-in và chia sẻ mạng xã hội; kết nối IoT dữ liệu thời gian thực; hoạt động đa nền tảng trên di động, máy tính và kính VR. Vera – trợ lý AI – giúp học sinh tiếp cận kiến thức trực quan và hiệu quả hơn.
    Liên hệ:
    Website: https://eduverse3d.com
    Email: info@eduverse3d.com
    Hotline: 0906854541
    `
}

function veraAvatar(nodes, materials) {
    return (
        <>
            <primitive object={nodes.Hips} />
            <skinnedMesh
                name="Wolf3D_Body"
                geometry={nodes.Wolf3D_Body.geometry}
                material={materials.Wolf3D_Body}
                skeleton={nodes.Wolf3D_Body.skeleton}
            />
            <skinnedMesh
                name="Wolf3D_Outfit_Bottom"
                geometry={nodes.Wolf3D_Outfit_Bottom.geometry}
                material={materials.Wolf3D_Outfit_Bottom}
                skeleton={nodes.Wolf3D_Outfit_Bottom.skeleton}
            />
            <skinnedMesh
                name="Wolf3D_Outfit_Footwear"
                geometry={nodes.Wolf3D_Outfit_Footwear.geometry}
                material={materials.Wolf3D_Outfit_Footwear}
                skeleton={nodes.Wolf3D_Outfit_Footwear.skeleton}
            />
            <skinnedMesh
                name="Wolf3D_Outfit_Top"
                geometry={nodes.Wolf3D_Outfit_Top.geometry}
                material={materials.Wolf3D_Outfit_Top}
                skeleton={nodes.Wolf3D_Outfit_Top.skeleton}
            />
            <skinnedMesh
                name="Wolf3D_Hair"
                geometry={nodes.Wolf3D_Hair.geometry}
                material={materials.Wolf3D_Hair}
                skeleton={nodes.Wolf3D_Hair.skeleton}
            />
            <skinnedMesh
                name="EyeLeft"
                geometry={nodes.EyeLeft.geometry}
                material={materials.Wolf3D_Eye}
                skeleton={nodes.EyeLeft.skeleton}
                morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
            />
            <skinnedMesh
                name="EyeRight"
                geometry={nodes.EyeRight.geometry}
                material={materials.Wolf3D_Eye}
                skeleton={nodes.EyeRight.skeleton}
                morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
                morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
            />
            <skinnedMesh
                name="Wolf3D_Head"
                geometry={nodes.Wolf3D_Head.geometry}
                material={materials.Wolf3D_Skin}
                skeleton={nodes.Wolf3D_Head.skeleton}
                morphTargetDictionary={nodes.Wolf3D_Head.morphTargetDictionary}
                morphTargetInfluences={nodes.Wolf3D_Head.morphTargetInfluences}
            />
            <skinnedMesh
                name="Wolf3D_Teeth"
                geometry={nodes.Wolf3D_Teeth.geometry}
                material={materials.Wolf3D_Teeth}
                skeleton={nodes.Wolf3D_Teeth.skeleton}
                morphTargetDictionary={nodes.Wolf3D_Teeth.morphTargetDictionary}
                morphTargetInfluences={nodes.Wolf3D_Teeth.morphTargetInfluences}
            />
        </>
    )
}


export {
    veraPrompt,
    veraAvatar,
};
